<ng-container *transloco="let t">
  @if (!isAdminRole) {

    <ul ngbNav #nav="ngbNav" class="nav-underline pb-4">
      <li [ngbNavItem]="1">
        <a ngbNavLink class="d-flex align-items-center">
          {{ t("administrator.discounts.management.codes.and.discounts") }}
        </a>
        <ng-template ngbNavContent>
          <ng-template [ngTemplateOutlet]="codesAndDiscounts">
          </ng-template>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  }

  <ng-template #codesAndDiscounts>
    <div class="admin-card">
      <app-admin-actions-header [isXlsVisible]="true" [isPdfVisible]="false">
        <div slot="leadingWidgets" class="d-flex flex-column flex-md-row">
          <div class="pe-3">
            <app-rounded-button [label]="t('administrator.discounts.management.display.active.codes')"
                                [btnClass]="'rounded-button--black-outline'"></app-rounded-button>
          </div>
          <app-rounded-button [label]="t('administrator.discounts.management.create.new.code')"
                              (onClick)="createNewCode()" [btnClass]="'nowrap btn-block w-100'"><i
            class="bi bi-plus-circle pe-2"></i></app-rounded-button>
        </div>
      </app-admin-actions-header>
      @if (listOfDiscounts && listOfDiscounts.length > 0) {

        <div class="d-flex">
          <div class="flex-grow-1" style="overflow-x: hidden ">
            <div class="table-responsive d-xl-block d-none">
              <table class="table width-200 dark-header table-last-row-no-border">
                <thead>
                <tr>
                  <th>{{ t("administrator.discounts.management.discountType") }}</th>
                  <th>{{ t("administrator.discounts.management.discountCode") }}</th>
                  <th>{{ t("administrator.discounts.management.name") }}</th>
                  <th>{{ t("administrator.discounts.management.description") }}</th>
                  <th class="status-column-width">{{ t("administrator.discounts.management.activityStatus") }}</th>
                  <th>{{ t("administrator.discounts.management.applicationOfDiscount") }}</th>
                  <th>{{ t("administrator.discounts.management.amountOrPercentage") }}</th>
                  <th>{{ t("administrator.discounts.management.validFrom") }}</th>
                  <th>{{ t("administrator.discounts.management.validTo") }}</th>
                  <th
                    class="discount-covers-column">{{ t("administrator.discounts.management.whatDiscountCovers") }}
                  </th>
                  <th>{{ t("administrator.discounts.management.usageLimit") }}</th>
                  <th>{{ t("administrator.discounts.management.maxAllowed") }}</th>
                  <th>{{ t("administrator.discounts.management.singleUsageOfDiscount") }}</th>
                  <th class="events-column">{{ t("administrator.discounts.management.events") }}</th>
                  <th class="races-column">{{ t("administrator.discounts.management.races") }}</th>
                </tr>
                </thead>
                <tr app-table-header-separator></tr>
                <tbody>
                  @for (discount of listOfDiscounts;track discount) {
                    <tr>
                      <td class="center-align">
                        <div class="status-badge"
                             [ngClass]="{'accepted': discount.discountType === 1 , 'publishing': discount.discountType === 2, 'on-hold': discount.discountType === 3,'denied': discount.discountType === 4}">
                  <span class="fw-bold text-uppercase">
                    {{ t("administrator.discounts.management.discountType." + discount.discountType) | uppercase }}
                  </span>
                        </div>
                      </td>
                      <td class="center-align">{{ discount.discountCode }}</td>
                      <td class="center-align">{{ discount.name }}</td>
                      <td class="center-align">{{ discount.description }}</td>
                      <td class="center-align">
                        <div class="status-badge"
                             [ngClass]="{'accepted': discount.active === true, 'denied': discount.active !== true }">
                  <span class="fw-bold">
                    @if (discount.active === true) {
                      {{ t('administrator.discounts.management.activityStatus.active') }}
                    } @else if (discount.active === false) {
                      {{ t('administrator.discounts.management.activityStatus.inactive') }}
                    } @else {
                      {{ "-" }}
                    }
                  </span>
                        </div>
                      </td>
                      <td class="center-align">
                        @if (discount.applicationOfDiscountWithPercentage === true) {
                          {{ t('administrator.discounts.management.applicationOfDiscount.percentages') }}
                        } @else if (discount.applicationOfDiscountWithPercentage === false) {
                          {{ t('administrator.discounts.management.applicationOfDiscount.fixedAmount') }}
                        } @else {
                          {{ "-" }}
                        }
                      </td>
                      <td class="center-align">{{ discount.amount |myCurrency }}</td>
                      <td class="center-align">{{ discount.dateFrom | date }}</td>
                      <td class="center-align">{{ discount.dateTo | date }}</td>
                      <td class="center-align">
                        @if (discount.discountCovers === DiscountCoversType.REGISTRATION_FEE) {
                          <span class="text-truncate">
                          {{ t('administrator.discounts.management.whatDiscountCovers.registrationFee') }}
                          </span>
                        } @else if (discount.discountCovers === DiscountCoversType.ALL_CHARGES) {
                          <span class="text-truncate">
                          {{ t('administrator.discounts.management.whatDiscountCovers.allChargesItems') }}
                          </span>
                        } @else {
                          {{ "-" }}
                        }
                      </td>
                      <td class="center-align">
                        @if (discount.usageLimit === true) {
                          {{ t('administrator.discounts.management.usageLimit.yes') }}
                        } @else if (discount.usageLimit === false) {
                          {{ t('administrator.discounts.management.usageLimit.no') }}
                        } @else {
                          {{ "-" }}
                        }
                      </td>
                      <td class="center-align">{{
                          discount.usageMaxAllowed ?? "-"
                        }}
                      </td>
                      <td class="center-align">
                        @if (discount.standaloneUsageOfDiscount === true) {
                          {{ t('administrator.discounts.management.singleUsageOfDiscount.yes') }}
                        } @else if (discount.standaloneUsageOfDiscount === false) {
                          {{ t('administrator.discounts.management.singleUsageOfDiscount.no') }}
                        } @else {
                          {{ "-" }}
                        }
                      </td>
                      <td class="center-align">
                        <div class="d-flex align-items-center">
                          @if ((discount.events?.length ?? 0) > 0) {
                            @if (discount.events!.length === 1) {
                              <span class="text-truncate">
                            <app-language-output [hrLabel]="discount.events![0]!.name"
                                                 [enLabel]="discount.events![0]!.nameEng"
                                                 [itLabel]="discount.events![0]!.nameIta"
                                                 [siLabel]="discount.events![0]!.nameSlo"
                                                 [defaultLanguage]="discount.events![0]!.defaultLanguage"
                                                 [languages]="languages"/>
                            </span>
                            } @else {
                              <span class="text-truncate">
                            <app-language-output [hrLabel]="discount.events![0]!.name"
                                                 [enLabel]="discount.events![0]!.nameEng"
                                                 [itLabel]="discount.events![0]!.nameIta"
                                                 [siLabel]="discount.events![0]!.nameSlo"
                                                 [defaultLanguage]="discount.events![0]!.defaultLanguage"
                                                 [languages]="languages"/>
                            </span>
                              <span class="unread-msg-circle--inverted ms-2">
                              {{ discount.events?.length }}
                            </span>
                            }
                          } @else {
                            {{ "-" }}
                          }
                        </div>
                      </td>
                      <td class="center-align">
                        <div class="d-flex align-items-center">
                          @if ((discount.events?.length ?? 0) > 0 && (discount.events![0]!.racesList?.length ?? 0)
                          > 0) {
                            @if (getNumberOfRacesOnDiscount(discount) === 1) {
                              <span class="text-truncate">
                            <app-language-output [hrLabel]="discount.events![0]!.racesList![0]!.name"
                                                 [enLabel]="discount.events![0]!.racesList![0]!.nameEng"
                                                 [itLabel]="discount.events![0]!.racesList![0]!.nameIta"
                                                 [siLabel]="discount.events![0]!.racesList![0]!.nameSlo"
                                                 [defaultLanguage]="discount.events![0]!.defaultLanguage"
                                                 [languages]="languages"/>
                            </span>
                            } @else {
                              <span class="text-truncate">
                            <app-language-output [hrLabel]="discount.events![0]!.racesList![0]!.name"
                                                 [enLabel]="discount.events![0]!.racesList![0]!.nameEng"
                                                 [itLabel]="discount.events![0]!.racesList![0]!.nameIta"
                                                 [siLabel]="discount.events![0]!.racesList![0]!.nameSlo"
                                                 [defaultLanguage]="discount.events![0]!.defaultLanguage"
                                                 [languages]="languages"/>
                            </span>
                              <span class="unread-msg-circle--inverted ms-2">
                              {{ getNumberOfRacesOnDiscount(discount) }}
                            </span>
                            }
                          } @else {
                            {{ "-" }}
                          }
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div class="d-xl-block d-none">
            <table class="table dark-header table-last-row-no-border" style="table-layout: auto !important;">
              <thead>
              <tr>
                <th class="more-th">
                  {{ t("app.common.edit") }}
                </th>
              </tr>
              </thead>
              <tr app-table-header-separator></tr>
              <tbody>
                @for (discount of listOfDiscounts;track discount) {
                  <tr>
                    <td class="more-td text-end center-align">
                      <ng-template *ngTemplateOutlet="discountActionsDropdown; context:{ $implicit: discount}">
                      </ng-template>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      <!-- Mobile table -->
      @for (discount of listOfDiscounts;let isLast = $last;track discount) {
        <div class="d-block d-xl-none">
          <div class="d-flex justify-content-center align-items-center mobile-table-row" [class.isLastRow]="isLast">
            <div class="flex-grow-1">
              <div class="d-flex flex-column" [class.isLastRow]="isLast">
                <div>
                  {{ t("administrator.discounts.management.discountType") }}: {{
                    t(
                      "administrator.discounts.management.discountType." + discount.discountType)
                  }}
                </div>
                <div>
                  {{ t("administrator.discounts.management.discountCode") }}: {{ discount.discountCode }}
                </div>
                <div>
                  {{ t("administrator.discounts.management.name") }}: {{ discount.name }}
                </div>
                <div>
                  {{ t("administrator.discounts.management.description") }}: {{ discount.description }}
                </div>
                <div>
                  {{ t("administrator.discounts.management.activityStatus") }}:
                  <div class="status-badge ms-1"
                       [ngClass]="{'accepted': discount.active === true, 'denied': discount.active !== true }">
                  <span class="fw-bold">
                    @if (discount.active === true) {
                      {{ t('administrator.discounts.management.activityStatus.active') }}
                    } @else if (discount.active === false) {
                      {{ t('administrator.discounts.management.activityStatus.inactive') }}
                    } @else {
                      {{ "-" }}
                    }
                  </span>
                  </div>
                </div>
                <div>{{ t("administrator.discounts.management.applicationOfDiscount") }}:
                  @if (discount.applicationOfDiscountWithPercentage === true) {
                    {{ t('administrator.discounts.management.applicationOfDiscount.percentages') }}
                  } @else if (discount.applicationOfDiscountWithPercentage === false) {
                    {{ t('administrator.discounts.management.applicationOfDiscount.fixedAmount') }}
                  } @else {
                    {{ "-" }}
                  }
                </div>
                <div>{{ t("administrator.discounts.management.amountOrPercentage") }}
                  :{{ discount.amount |myCurrency }}
                </div>
                <div>{{ t('administrator.discounts.management.validFrom') }}:{{ (discount.dateFrom | date) }}</div>
                <div>{{ t('administrator.discounts.management.validTo') }}:{{ (discount.dateTo | date) }}</div>
                <div>{{ t("administrator.discounts.management.whatDiscountCovers") }}:
                  @if (discount.discountCovers === DiscountCoversType.REGISTRATION_FEE) {
                    {{ t('administrator.discounts.management.whatDiscountCovers.registrationFee') }}
                  } @else if (discount.discountCovers === DiscountCoversType.ALL_CHARGES) {
                    {{ t('administrator.discounts.management.whatDiscountCovers.allChargesItems') }}
                  } @else {
                    {{ "-" }}
                  }
                </div>
                <div>{{ t("administrator.discounts.management.usageLimit") }}:
                  @if (discount.usageLimit === true) {
                    {{ t('administrator.discounts.management.usageLimit.yes') }}
                  } @else if (discount.usageLimit === false) {
                    {{ t('administrator.discounts.management.usageLimit.no') }}
                  } @else {
                    {{ "-" }}
                  }
                </div>
                <div>{{ t("administrator.discounts.management.maxAllowed") }}:{{
                    discount.usageMaxAllowed ?? "-"
                  }}
                </div>
                <div>{{ t("administrator.discounts.management.singleUsageOfDiscount") }}:
                  @if (discount.standaloneUsageOfDiscount === true) {
                    {{ t('administrator.discounts.management.singleUsageOfDiscount.yes') }}
                  } @else if (discount.standaloneUsageOfDiscount === false) {
                    {{ t('administrator.discounts.management.singleUsageOfDiscount.no') }}
                  } @else {
                    {{ "-" }}
                  }
                </div>

                <div>{{ t("administrator.discounts.management.events") }}:
                  @if ((discount.events?.length ?? 0) > 0) {
                    @if (discount.events!.length === 1) {
                      <app-language-output [hrLabel]="discount.events![0]!.name"
                                           [enLabel]="discount.events![0]!.nameEng"
                                           [itLabel]="discount.events![0]!.nameIta"
                                           [siLabel]="discount.events![0]!.nameSlo"
                                           [defaultLanguage]="discount.events![0]!.defaultLanguage"
                                           [languages]="languages"/>
                    } @else {
                      <app-language-output [hrLabel]="discount.events![0]!.name"
                                           [enLabel]="discount.events![0]!.nameEng"
                                           [itLabel]="discount.events![0]!.nameIta"
                                           [siLabel]="discount.events![0]!.nameSlo"
                                           [defaultLanguage]="discount.events![0]!.defaultLanguage"
                                           [languages]="languages"/>
                      {{ discount.events?.length }}
                    }
                  } @else {
                    {{ "-" }}
                  }
                </div>
                <div>{{ t("administrator.discounts.management.races") }}:
                  @if ((discount.events?.length ?? 0) > 0 && (discount.events![0]!.racesList?.length ?? 0) > 0) {
                    @if (getNumberOfRacesOnDiscount(discount) === 1) {
                      <app-language-output [hrLabel]="discount.events![0]!.racesList![0]!.name"
                                           [enLabel]="discount.events![0]!.racesList![0]!.nameEng"
                                           [itLabel]="discount.events![0]!.racesList![0]!.nameIta"
                                           [siLabel]="discount.events![0]!.racesList![0]!.nameSlo"
                                           [defaultLanguage]="discount.events![0]!.defaultLanguage"
                                           [languages]="languages"/>
                    } @else {
                      <app-language-output [hrLabel]="discount.events![0]!.racesList![0]!.name"
                                           [enLabel]="discount.events![0]!.racesList![0]!.nameEng"
                                           [itLabel]="discount.events![0]!.racesList![0]!.nameIta"
                                           [siLabel]="discount.events![0]!.racesList![0]!.nameSlo"
                                           [defaultLanguage]="discount.events![0]!.defaultLanguage"
                                           [languages]="languages"/>
                      {{ getNumberOfRacesOnDiscount(discount) }}
                    }
                  } @else {
                    {{ "-" }}
                  }
                </div>

                <ng-template *ngTemplateOutlet="discountActionsDropdown; context:{ $implicit: discount}">
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </ng-template>
  <ng-template #discountActionsDropdown let-discount>
    <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
      <span class="menu-icon" id="discountActionsDropdown" ngbDropdownToggle>
        <i class="fas fa-ellipsis-v"></i>
      </span>
      <ul aria-labelledby="discountActionsDropdown" ngbDropdownMenu>
        <li (click)="goToDiscountDetails(discount)" ngbDropdownItem>{{ t("app.common.details") }}</li>
        <!--        <li ngbDropdownItem (click)="deactivateDiscount(discount)" *ngIf="discount.isActive">
                  {{t("administrator.discounts.management.deactivate")}}</li>
                <li ngbDropdownItem (click)="activateDiscount(discount)" *ngIf="!discount.isActive">
                  {{t("administrator.discounts.management.activate")}}</li>-->
        <li ngbDropdownItem (click)="deleteDiscount(discount)">
          {{ t("administrator.discounts.management.delete") }}
        </li>
      </ul>
    </div>
  </ng-template>
  @if (isAdminRole) {
    <ng-template [ngTemplateOutlet]="codesAndDiscounts">
    </ng-template>
  }


  @if (authenticationService.isAdmin()) {
    <app-action-buttons-row [saveVisible]="false"/>
  }

</ng-container>
